import {
  REMOVETAB,
  ADDTAB,
  FETCH_TABS,
  CHANGEACTIVETAB,
  STORE_ANALYST_TO_LOCALSTORAGE
} from '@/store/actions.type'
import {
  START_ADDING_TAB,
  END_ADDING_TAB,
  STARTED_MODIFIE_TAB,
  ENDED_MODIFIE_TAB,
  START_CHANGE_ACTIVE_TAB,
  MODIFIE_TAB,
  DTM_CHANGE_TAB
} from '@/store/mutations.type'

import localStorage from '@/api/localStorage'
import { urlParam } from '@/helper'
const tabHelper = {
  getTabsDetails: function ( track ) {
    this.tabDetailFromUrl() /* Used for opening tab based on external link */

    localStorage.savelocalStorage( 'globaloutlookTab', false )
    localStorage.savelocalStorage( 'chart', false )
    localStorage.savelocalStorage( 'activetab', 0 )
    var tabObj = []
    var obj = {}

    var tablocalStorage = JSON.parse( localStorage.getlocalStorage( 'rvTabs' ) )
    if ( tablocalStorage == null || tablocalStorage == '' ) {
      obj['name'] = 'Dashboard'
      obj['id'] = 'Dashboard'
      obj['state'] = true
      obj['isactive'] = 'active'
      dtm['pageName'] = 'won : research : research-library : dashboard'
      dtm['siteSection3'] = 'none'
      tabObj[0] = obj
    } else {
      var findlasttab = tablocalStorage[tablocalStorage.length - 1].id

      if ( findlasttab === 'globaloutlook' ) {
        localStorage.savelocalStorage( 'globaloutlookTab', false )
      }

      if ( findlasttab === 'Dashboard' ) {
        localStorage.savelocalStorage( 'chart', true )
      }
      tabObj = tablocalStorage
      /** DTM & Adobe Analytics START**/
      var findlasttype = tablocalStorage[tablocalStorage.length - 1].type
      if ( findlasttype ) {
        // if (findlasttype == 'search') {
        //     dtm['pageName'] =
        //         'won : research : research-library : search-results '
        //     dtm['siteSection3'] = 'research : search-results'
        // }
        // if (findlasttype == 'post') {
        //     if (tablocalStorage[tablocalStorage.length - 1].articleAttachment) {
        //         dtm['articleAttachment'] = tablocalStorage[tablocalStorage.length - 1].articleAttachment
        //     }
        //     if (tablocalStorage[tablocalStorage.length - 1].articleDate) {
        //         dtm['articleDate'] = tablocalStorage[tablocalStorage.length - 1].articleDate
        //     }
        //     if (tablocalStorage[tablocalStorage.length - 1].articleTitle) {
        //         dtm['articleTitle'] = tablocalStorage[tablocalStorage.length - 1].articleTitle
        //     }
        //     dtm['articleCat'] = tablocalStorage[tablocalStorage.length - 1].name
        //     dtm['articleName'] = tablocalStorage[tablocalStorage.length - 1].id
        //     dtm['siteSection3'] = tablocalStorage[tablocalStorage.length - 1].name
        //     dtm['pageName'] =
        //         'won : research : research-library : ' +
        //         tablocalStorage[tablocalStorage.length - 1].name
        // }
        // if (findlasttype == 'analyst') {
        //     dtm['pageName'] = 'won : research : research-library : analyst '
        //     dtm['siteSection3'] = 'research : analyst'
        // }
        // if (findlasttype == 'globaloutlook') {
        //     dtm['pageName'] = 'won : dashboard : global-outlook '
        //     dtm['siteSection2'] = 'global-outlook'
        //     dtm['siteSection3'] = 'none'
        // }
      } else {
        dtm['pageName'] = 'won : research : research-library : dashboard'
        dtm['siteSection3'] = 'none'
      }
      /** DTM & Adobe Analytics START**/
    }

    if ( track ) {
      digitalData = dtm
      // _satellite.track( 'researchView' )
    }

    return tabObj
  },

  tabDetailFromUrl: function () {
    var currenttabfromUrl = ''
    var checkTabExistInlocalStorage = false
    var tabData = {}
    var currenttabIndex
    var tabId = urlParam.tab
    if ( urlParam.tab ) {
      currenttabfromUrl = urlParam.tab

      var allTabDetails = this.checkingTab()
      if ( currenttabfromUrl == 'search' ) {
        tabData = this.taboOjectSearch( 'search' )
      } else if ( currenttabfromUrl == 'analyst' ) {
        var analystCategory = decodeURI( urlParam.analystname )
        var tabDet = {
          type: urlParam.tab,
          categoryName: analystCategory,
          post: urlParam.analystid
        }
        tabData = this.tabObjectAnlyst( tabDet )
      } else if ( currenttabfromUrl == 'globaloutlook' ) {
        var tabDet = { type: 'globaloutlook', categoryName: 'GLOBAL OUTLOOK' }
        tabData = this.tabOjectGobalOutlook( tabDet )
      } else if ( currenttabfromUrl == 'post' ) {
        var category = decodeURI( urlParam.category )
        tabDet = {
          categoryName: category,
          post: {
            id: urlParam.pid,
            pcreated: urlParam.pdate,
            post_type: urlParam.post_type
          }
        }
        tabData = this.tabOjectPost( tabDet )
      }

      allTabDetails.map( function ( allTabDetails, index ) {
        if ( allTabDetails.id == tabId ) {
          currenttabIndex = allTabDetails.id
          checkTabExistInlocalStorage = true
        }
      } )

      if ( !checkTabExistInlocalStorage ) {
        // console.log('save ')
        window.urlParam = false
        // tabs will save to localStorage
        allTabDetails[allTabDetails.length] = tabData
        // console.log('allTabDetails.length', allTabDetails.length)
        localStorage.savelocalStorage( 'rvTabs', JSON.stringify( allTabDetails ) )
      } else {
        window.urlParam = currenttabIndex
      }
    }
  },

  checkingTab: function () {
    var urlTab = {}
    urlTab['name'] = 'Dashboard'
    urlTab['id'] = 'Dashboard'
    urlTab['state'] = true
    urlTab['isactive'] = 'active'
    var allTabDetails = []
    if ( localStorage.getlocalStorage( 'rvTabs' ) ) {
      allTabDetails = JSON.parse( localStorage.getlocalStorage( 'rvTabs' ) )
    } else {
      allTabDetails[0] = urlTab
    }
    return allTabDetails
  },

  insertLocalStorage: function ( tabsDetails ) {
    var stateTabs = []
    stateTabs = state.data
    stateTabs.push( tabsDetails )
    stateTabs.activeTab = tabsDetails.name
    this.saveToLocalStorage( stateTabs )
    return stateTabs
  },

  saveToLocalStorage: function ( tabsDetails ) {
    localStorage.savelocalStorage( 'rvTabs', JSON.stringify( tabsDetails ) )
  },
  modifieLocalStorage: function ( tabsDetails ) {
    this.saveToLocalStorage( tabsDetails )
  },
  changeTabName: function ( tabsDetails ) {
    // console.log( tabsDetails )
    //	console.log('getTabsDetails', this.getTabsDetails())
    // this is for update analyst name on change analyst name
    var tabs = this.getTabsDetails( false )
    var tabIndexTabid = this.returnIndex( tabsDetails.id )
    tabs[tabIndexTabid].name = tabsDetails.name
    this.saveToLocalStorage( tabs )
    return tabs
  },
  removeTab: function ( tabIndex ) {
    var stateTabs = []
    stateTabs = state.data
    var removeIndex = stateTabs
      .map( function ( stateTabs ) {
        return stateTabs.id
      } )
      .indexOf( tabIndex )
    stateTabs.splice( removeIndex, 1 )
    /*
        Doing footer display and hide, because footer is not required
        */
    var activeIn = stateTabs.length - 1
    // $('.footerMenu').removeClass('footerhide')
    // if (stateTabs[activeIn]['id'] == 'globaloutlook') {
    // 	$('.footerMenu').addClass('footerhide')
    // }
    $( '.footerMenu' ).css( 'display', '' )
    try {
      if ( stateTabs[activeIn]['id'] == 'globaloutlook' ) {
        $( '.footerMenu' ).css( 'display', 'none' )
      }
    } catch ( e ) {
      // console.log( 'tab issue', e )
    }

    return stateTabs
  },

  postDetails: function ( tabsDetails ) {
    var tabobj = {}
    if ( tabsDetails['post']['pdfsrc'] ) {
      tabobj['articleAttachment'] = tabsDetails['post']['pdffilename']
    } else if ( tabsDetails['post']['videosrc'] ) {
      tabobj['articleAttachment'] = tabsDetails['post']['video_url']
      var videoid = tabsDetails['post']['video_url'].split( '/' )
      videoid = videoid[videoid.length - 1]
      $.get( 'https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/' + videoid, function ( data ) {
        if ( data.title ) {
          tabobj['articleAttachment'] = data.title
        } else {
          tabobj['articleAttachment'] = tabsDetails['post']['video_url']
        }
      } )
    }
    if ( tabsDetails['post']['pcreated'] ) {
      tabobj['articleDate'] = tabsDetails['post']['pcreated']
    }
    if ( tabsDetails['post']['title'] ) {
      tabobj['articleTitle'] = tabsDetails['post']['title']
    }
    if ( !tabsDetails['post']['title'] && tabsDetails['post']['postname'] ) {
      tabobj['articleTitle'] = tabsDetails['post']['postname'] + ' ' + tabsDetails['post']['postdate']
      if ( !tabobj['articleAttachment'] ) {
        tabobj['articleAttachment'] = tabsDetails['post']['pdffilename']
      }
    }
    return tabobj
  },

  tabOjectPost: function ( tabsDetails ) {
    // console.log( 'tabOjectPost', tabsDetails )
    var tabobj = {}
    tabobj['name'] = tabsDetails.categoryName
    tabobj['id'] = tabsDetails.post.id + '_' + tabsDetails.post.post_type
    tabobj['pcreated'] = tabsDetails.post.pcreated
    tabobj['state'] = 'active'
    tabobj['type'] = 'post'
    tabobj['isclass'] = true
    tabobj['tabName'] = 'Post'
    var postData = this.postDetails( tabsDetails )
    if ( postData['articleAttachment'] ) {
      tabobj['articleAttachment'] = postData['articleAttachment']
    }
    if ( postData['articleDate'] ) {
      tabobj['articleDate'] = postData['articleDate']
    }
    if ( postData['articleTitle'] ) {
      tabobj['articleTitle'] = postData['articleTitle']
    }
    return tabobj
  },
  taboOjectSearch: function ( tabIndex ) {
    var tabobj = {}
    tabobj['name'] = 'Search Results'
    tabobj['id'] = 'search'
    tabobj['state'] = 'active'
    tabobj['type'] = 'search'
    tabobj['tabName'] = 'Search'
    tabobj['isclass'] = true
    return tabobj
  },
  tabOjectGobalOutlook: function ( tabsDetails ) {
    // console.log( 'tabOjectGobalOutlook', tabsDetails )
    var tabobj = {}
    tabobj['name'] = tabsDetails.categoryName
    tabobj['id'] = tabsDetails.type
    tabobj['state'] = 'active'
    tabobj['type'] = tabsDetails.type
    tabobj['isclass'] = true
    tabobj['tabName'] = 'Globaloutlook'
    return tabobj
  },

  tabObjectAnlyst: function ( tabsDetails ) {
    // console.log( tabsDetails )
    var tabobj = {}
    tabobj['name'] = tabsDetails.categoryName
    tabobj['id'] = tabsDetails.type
    tabobj['state'] = 'active'
    tabobj['type'] = tabsDetails.type
    tabobj['isclass'] = true
    tabobj['tabName'] = 'Anlyst'
    return tabobj
  },
  checkTabExist: function ( tabId ) {
    var stateTabs = []
    stateTabs = state.data
    var stateIndex = ''
    var indexExist = stateTabs.map( function ( stateTabs ) {
      if ( stateTabs.id == tabId ) {
        return false
      }
    } )
    return indexExist.indexOf( false ) > -1
  },
  returnIndex: function ( tabId ) {
    var stateTabs = []
    stateTabs = state.data
    var stateIndex = ''
    var indexExist = stateTabs.map( function ( stateTabs, index ) {
      if ( stateTabs.id == tabId ) {
        stateIndex = index
      }
    } )
    return stateIndex
  },
  returnTabName: function ( tabId ) {
    var stateTabs = []
    stateTabs = state.data
    var stateIndex = ''
    var indexExist = stateTabs.map( function ( stateTabs, index ) {
      if ( stateTabs.id == tabId ) {
        stateIndex = stateTabs.name
      }
    } )
    return stateIndex
  }
}
const state = {
  loading: false,
  data: tabHelper.getTabsDetails( true ),
  active: 0,
  activetabid: 'null'
}

var tabDataLc = JSON.parse( localStorage.getlocalStorage( 'rvTabs' ) )

var acitivetabidonload = ''
if ( tabDataLc ) {
  var length = tabDataLc.length
  acitivetabidonload = tabDataLc[length - 1]['id']
  if ( acitivetabidonload == 'analyst' ) {
    digitalData.analystName = tabDataLc[length - 1]['name']
  }
} else {
  acitivetabidonload = 'Dashboard'
}

state.activetabid = acitivetabidonload

const actions = {
  [STORE_ANALYST_TO_LOCALSTORAGE]( { commit }, data ) {
    // console.log( data )
    var tabdata = tabHelper.getTabsDetails( false )
    var tabindex = tabHelper.returnIndex( 'analyst' )
    tabdata[tabindex].name = data
    // console.log( 'tabdata', tabdata, tabindex )
    localStorage.savelocalStorage( 'rvTabs', JSON.stringify( tabdata ) )
  },
  [FETCH_TABS]( { commit }, data ) {
    var tabdata = tabHelper.getTabsDetails( false )
    return commit( START_ADDING_TAB, tabdata )
  },
  [CHANGEACTIVETAB]( { commit }, tabid ) {
    commit( START_CHANGE_ACTIVE_TAB, tabid )
    var activetab = localStorage.getlocalStorage( 'activetab' )
    if ( activetab != 0 ) {
      commit( DTM_CHANGE_TAB, tabid )
    }
    localStorage.savelocalStorage( 'activetab', 1 )
  },
  [ADDTAB]( { commit }, tabsDetails ) {
    localStorage.savelocalStorage( 'activetab', 1 )
    if ( tabsDetails['post'] ) {
      var postData = tabHelper.postDetails( tabsDetails )
      if ( postData['articleAttachment'] ) {
        dtm['articleAttachment'] = postData['articleAttachment']
      }
      if ( postData['articleDate'] ) {
        dtm['articleDate'] = postData['articleDate']
      }
      if ( postData['articleTitle'] ) {
        dtm['articleTitle'] = postData['articleTitle']
      }
    }
    if ( tabsDetails.type == 'post' ) {
      dtm['tabName'] = 'Post'
      tabsDetails = tabHelper.tabOjectPost( tabsDetails )
      dtm['articleCat'] = tabsDetails.name
      dtm['articleName'] = tabsDetails.id
      dtm['siteSection3'] = tabsDetails.name
      dtm['pageName'] =
                'won : research : research-library : ' + tabsDetails.name
      digitalData = dtm

      _satellite.track( 'researchArticleView' )
    }
    if ( tabsDetails.type == 'globaloutlook' ) {
      window.globaloutlookcreated = new Date()
      localStorage.savelocalStorage( 'globaloutlookTab', true )
      tabsDetails = tabHelper.tabOjectGobalOutlook( tabsDetails )
      dtm['tabName'] = 'Globaloutlook'
      dtm['pageName'] = 'won : dashboard : global-outlook '
      dtm['siteSection2'] = 'global-outlook'
      dtm['siteSection3'] = 'none'
      digitalData = dtm
      _satellite.track( 'researchView' )
    }
    if ( tabsDetails.type == 'search' ) {
      dtm['tabName'] = 'Search'
      tabsDetails = tabHelper.taboOjectSearch( tabsDetails )
      dtm['pageName'] = 'won : research : research-library : search-results '
      dtm['siteSection3'] = 'research : search-results'
      digitalData = dtm

      _satellite.track( 'researchSearchResults' )
    }
    if ( tabsDetails.type == 'analyst' ) {
      dtm['tabName'] = 'Analyst'
      tabsDetails = tabHelper.tabObjectAnlyst( tabsDetails )
      dtm['pageName'] = 'won : research : research-library : analyst '
      dtm['siteSection3'] = 'research : analyst'
      digitalData = dtm
    }

    var tabIdValue = tabHelper.checkTabExist( tabsDetails.id )
    if ( !tabIdValue ) {
      // console.log( 'tabs exist', tabIdValue )
      // commit(START_ADDING_TAB)
      var obj = {}
      var tabsDetailsUpdate = tabHelper.insertLocalStorage( tabsDetails )
      obj['currentpostid'] = tabsDetails.id
      obj['tabsDetailsUpdate'] = tabsDetailsUpdate
      commit( END_ADDING_TAB, obj )
    } else {
      if ( tabsDetails.type == 'analyst' ) {
        var obj = {}
        // console.log( 'analyst', tabsDetails )
        var tabsDetailsUpdate = tabHelper.changeTabName( tabsDetails )
        obj['currentpostid'] = tabsDetails.id
        obj['tabsDetailsUpdate'] = tabsDetailsUpdate
        commit( MODIFIE_TAB, obj )
      }
      // set active tab sate for requested tab
    }
    commit( START_CHANGE_ACTIVE_TAB, tabsDetails.id )
    var allTabDetails = []
    allTabDetails = JSON.parse( localStorage.getlocalStorage( 'rvTabs' ) )
    if ( allTabDetails.length > 9 ) {
      tabHelper.removeTab( allTabDetails[1].id )
      debugger
      localStorage.savelocalStorage( 'rvTabs', JSON.stringify( state.data ) )
      var alertMessage =
                '' +
                '<div class="alert alert-success alert-dismissible" style="margin-top:10px;width:25%;background-color:white;border-radius:0px;border-color:white;">' +
                '<a href="#" class="close" data-dismiss="alert" aria-label="close" style="color:#2ba16c">&times;</a>' +
                '<p style="color:black;font-weight: -100;">Max number of 10 tabs has been reached.</p>' +
                '</div>'
      $( '.card-header' ).append( alertMessage )
      var timeout = null
      timeout = setTimeout( function () {
        $( '.alert-dismissible' ).remove()
      }, 5000 )
    }
    window.scrollTo( 0, 0 )
  },

  [REMOVETAB]( { commit }, tabId ) {
    digitalData['tabName'] = tabHelper.returnTabName( tabId )
    _satellite.track( 'researchLibraryTabClose' )

    // console.log( 'remove tab', tabId )

    if ( tabId == 'globaloutlook' ) {
      var nowTime = new Date().getTime()
      var gobalOutlooktime = new Date( window.globaloutlookcreated ).getTime()
      //	var startDate = new Date();

      /* var seconds = (nowTime - gobalOutlooktime) / 1000;
      if (seconds < 10 && (navigator.userAgent.match(/(MSIE)/) && navigator.userAgent.match(/(.NET CLR)/))) {
       return true;
       }
       */
    }

    if ( tabId == 'analyst' ) {
      localStorage.destroyLocalStorage( 'analystTab' )
    }
    if ( tabId == 'search' ) {
      localStorage.destroyLocalStorage( 'searchTab' )
    }

    commit( STARTED_MODIFIE_TAB )
    var tabsDetailsUpdate = tabHelper.removeTab( tabId )
    tabHelper.modifieLocalStorage( tabsDetailsUpdate )
    commit( ENDED_MODIFIE_TAB, tabsDetailsUpdate )
  }
}
const mutations = {
  [STARTED_MODIFIE_TAB]( state ) {
    state = {
      activetabid: state.activetab,
      data: {},
      activetabid: ''
    }
  },

  [DTM_CHANGE_TAB]( state, acitivetabid ) {
    state.data.forEach( singletabs => {
      if ( singletabs.id == acitivetabid ) {
        delete dtm['articleAttachment']
        delete dtm['articleDate']
        delete dtm['articleTitle']
        dtm['articleCat'] = ''
        dtm['articleName'] = ''
        if ( singletabs.id == 'Dashboard' ) {
          dtm['tabName'] = 'Dashboard'
          dtm['pageName'] = 'won : research : research-library : dashboard'
          dtm['siteSection3'] = 'none'
          digitalData = dtm
          _satellite.track( 'researchView' )
        }
        if ( singletabs.type == 'globaloutlook' ) {
          dtm['tabName'] = 'Globaloutlook'
          dtm['pageName'] = 'won : dashboard : global-outlook '
          dtm['siteSection2'] = 'global-outlook'
          dtm['siteSection3'] = 'none'
          digitalData = dtm
          _satellite.track( 'researchView' )
        }
        if ( singletabs.type == 'search' ) {
          dtm['tabName'] = 'Search'
          dtm['pageName'] =
                        'won : research : research-library : search-results '
          dtm['siteSection3'] = 'research : search-results'
          digitalData = dtm
          _satellite.track( 'researchSearchResults' )
        }
        if ( singletabs.type == 'analyst' ) {
          dtm['tabName'] = 'Analyst'
          dtm['pageName'] = 'won : research : research-library : analyst '
          dtm['siteSection3'] = 'research : analyst'
          digitalData = dtm
          _satellite.track( 'researchView' )
        }
        if ( singletabs.type == 'post' ) {
          dtm['tabName'] = 'Post'
          if ( singletabs['articleAttachment'] ) {
            dtm['articleAttachment'] = singletabs['articleAttachment']
          }
          if ( singletabs['articleDate'] ) {
            dtm['articleDate'] = singletabs['articleDate']
          }
          if ( singletabs['articleTitle'] ) {
            dtm['articleTitle'] = singletabs['articleTitle']
          }
          dtm['articleCat'] = singletabs.name
          dtm['articleName'] = singletabs.id
          dtm['siteSection3'] = singletabs.name
          dtm['pageName'] =
                        'won : research : research-library : ' + singletabs.name
          digitalData = dtm
          _satellite.track( 'researchArticleView' )
        }
      }
    } )
  },

  [START_CHANGE_ACTIVE_TAB]( state, acitivetabid ) {
    // console.log( 'current tab', acitivetabid )
    var currentIndex = tabHelper.returnIndex( acitivetabid )
    //  console.log( currentIndex )
    state.active = currentIndex
    state.activeTabIndex = currentIndex
    state.activetabid = acitivetabid
  },
  [START_ADDING_TAB]( state ) {
    state = {
      data: state.data,
      activetabid: state.activetab
    }
  },
  [END_ADDING_TAB]( state, tabsData ) {
    state = {
      active: tabsData.tabsDetailsUpdate.length,
      activetabid: tabsData.currentpostid,
      loading: tabsData.currentpostid,
      data: tabsData.tabsDetailsUpdate
    }
    // console.log( 'end adding tab', state )
  },
  [MODIFIE_TAB]( state, tabsData ) {
    // console.log( 'MODIFIE_TAB', tabsData )
    state.data = tabsData.tabsDetailsUpdate
  },
  [ENDED_MODIFIE_TAB]( state, tabsData ) {
    var length = tabsData.length
    var acitivetabid = tabsData[length - 1]['id']
    state.activetabid = acitivetabid
    state = {
      data: tabsData,
      activetabid: tabsData.id
    }
    // console.log( state )
  }
}

const getters = {
  tabsData( state ) {
    return state.data
  },
  activeTabIndex( state ) {
    return state.active
  },
  activetabid( state ) {
    return state.activetabid
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tab.js